import en from './en/en.js'
import es from './es/es.js'

export default {
  en: en,
  es: es
}